/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Mfa.vue?vue&type=template&id=1a874e18&scoped=true&"
import script from "./Mfa.vue?vue&type=script&lang=js&"
export * from "./Mfa.vue?vue&type=script&lang=js&"
import style0 from "./Mfa.vue?vue&type=style&index=0&id=1a874e18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a874e18",
  null
  
)

export default component.exports